import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import styled from 'styled-components';

// Styled container for the image

const ImageContainerStyled = styled.div`
  width: 200px; /* Fixed width */
  height: 200px; /* Fixed height */
  background-color: #8F8F8F; /* Fallback background */
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const StyledImage = styled(LazyLoadImage)`
  width: 100%;
  height: 100%;
  object-fit: contain; /* Ensures image is contained without stretching */
  object-position: center; /* Centers the image */
`;

const ImageContainer = ({ src, alt, isNewTab = false, onClick }) => {
  return (
    <ImageContainerStyled isNewTab={isNewTab}>
      <StyledImage
        src={src}
        alt={alt || 'Facebook post image'}
        effect="blur"
        onClick={onClick}
      // placeholderSrc="https://via.placeholder.com/400" // Fallback image
      />
    </ImageContainerStyled>
  );
};

export default ImageContainer;
